module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "device-map",
    attrs: {
      "fluid": ""
    }
  }, [_c('snackBar'), _vm._v(" "), _c('creationForm', {
    attrs: {
      "orgId": _vm.orgId,
      "location": _vm.coordinates
    }
  }), _vm._v(" "), _c('coordinatesForm', {
    attrs: {
      "dialog": _vm.dialog,
      "coordinates": _vm.stringyfiedCoords
    },
    on: {
      "update:dialog": function($event) {
        _vm.dialog = $event
      },
      "update:coordinates": function($event) {
        _vm.stringyfiedCoords = $event
      },
      "save": function($event) {
        return _vm.updateMap()
      }
    }
  }), _vm._v(" "), _c('markerWindow', {
    attrs: {
      "dialog": _vm.dialog,
      "lat": _vm.fixCoordinates(_vm.coordinates.lat),
      "lng": _vm.fixCoordinates(_vm.coordinates.lng)
    },
    on: {
      "update:dialog": function($event) {
        _vm.dialog = $event
      }
    }
  }), _vm._v(" "), _c('v-img', {
    staticClass: "centered-marker",
    attrs: {
      "src": _vm.icon
    }
  }), _vm._v(" "), _c('GmapMap', {
    ref: "mapRef",
    staticClass: "gmap",
    attrs: {
      "options": {
        zoomControl: false,
        scrollwheel: true,
        gestureHandling: 'greedy',
        draggable: true,
        scaleControl: false,
        mapTypeControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUi: false,
        MotionTrackingControl: true,

      },
      "center": {
        lat: -38.001088,
        lng: -57.544016
      },
      "zoom": _vm.zoom
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "fab-container",
    attrs: {
      "column": ""
    }
  }, [_c('div', [_c('v-btn', {
    attrs: {
      "small": "",
      "dark": "",
      "fab": "",
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.accessLocation()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "medium": "",
      "color": "black"
    }
  }, [_vm._v("gps_fixed")])], 1)], 1), _vm._v(" "), _c('div', [_c('v-btn', {
    attrs: {
      "small": "",
      "dark": "",
      "fab": "",
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.zoomControl(1)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "large": "",
      "color": "black"
    }
  }, [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('div', [_c('v-btn', {
    attrs: {
      "small": "",
      "dark": "",
      "fab": "",
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.zoomControl(-1)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "large": "",
      "color": "black"
    }
  }, [_vm._v("remove")])], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f6d35296","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Device/new/DeviceCreationMap.vue
// module id = 784
// module chunks = 11